<template>
    <vx-card title="Exception Form">
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Code</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" placeholder="Auto Generated" v-model="exception"
                            readonly />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Driver</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" v-model="driver" readonly />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Date</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" v-model="data.date" readonly />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Status</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" placeholder="Draft" :value="stsExcText(data.status)"
                            readonly />
                    </div>
                </div>
                <div class="vx-row w-full mt-2">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Notes</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-textarea class="w-full" v-model="data.notes" />
                    </div>
                </div>
                <div class="vx-row my-6 w-full">
                    <div class="vx-col sm:w-1/4 w-full">
                        <span>Note History</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <template v-for="note in history_notes">
                            <b v-bind:key="note">{{ note }}<br>
                            </b>
                        </template><br>
                    </div>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <table class="vs-table vs-table--tbody-table">
                    <thead>
                        <tr>
                            <th>DO/PI</th>
                            <th>is COD</th>
                            <th>POD Confirmed</th>
                            <th class="text-right">total PI</th>
                            <th class="text-right">total CIT</th>
                            <th class="text-right">total payment receive</th>
                            <th>Need Exception</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, index) in summary">
                            <tr :key="index">
                                <td>{{ item.do_code }}</td>
                                <td class="text-center">{{ item.is_cod == 1 ? 'Yes' : 'No' }}</td>
                                <td class="text-center">{{ item.pod_code != '' ? 'Yes' : 'No' }}</td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.so_total) }}</td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.billing_total) }}</td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.invoice_total) }}</td>
                                <td class="text-center">{{ needException(item) }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <vs-divider style="width: 100%; margin-left: 0%">Attachment</vs-divider>
        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <div class="vx-col sm:w-1/3 w-full">
                <span>File</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-4/5 w-full">
                    <input id="fileInput" name="file" class="w-full inputx" type="file" ref="file"
                        accept=".jpg, .jpeg, .png, .pdf" multiple />
                </div>
            </div>
        </div>

        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <div class="vx-col sm:w-1/3 w-full">
                <span></span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-button class="mr-3 mb-2" @click="handleAttachment">Add Attachment</vs-button>
                </div>
            </div>
        </div>

        <vs-divider style="width: 100%; margin-left: 0%">List Attachment</vs-divider>
        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <table class="vs-table vs-table--tbody-table">
                <template v-for="(tr, i) in data.file">
                    <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="tr.name">
                        <td class="td vs-table--td">{{ tr.name }}</td>
                        <td class="td vs-table--td">
                            <vx-tooltip text="Download" v-if="tr.path != ''">
                                <vs-button type="line" icon-pack="feather" @click.stop="downloadFileAwsS3(tr.path)"
                                    icon="icon-download" />
                            </vx-tooltip>
                        </td>
                        <td class="td vs-table--td">
                            <template>
                                <vx-tooltip text="Delete">
                                    <vs-button type="line" icon-pack="feather"
                                        @click.stop="handleDeleteAttachment(i, tr.id)" icon="icon-trash" />
                                </vx-tooltip>
                            </template>
                        </td>
                    </tr>
                </template>
            </table>
        </div>
        <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>

        <vs-popup title="Preview" :active.sync="showAttachment" :fullscreen="true">
            <iframe v-if="showAttachment" :src="attachmentPath" style="width: 100%; height: 80dvh" />
        </vs-popup>

        <div class="vx-row my-4">
            <div class="vx-col flex items-center gap-2">
                <vs-button v-if="!this.data.id || this.data.status == 0 || this.data.status == 3"
                    @click="handleSubmitWithoutApproval" color="primary" icon-pack="feather" icon="icon-save">
                    Save</vs-button>
                <vs-button v-if="!this.data.id || this.data.status == 0 || this.data.status == 3"
                    @click="handleSubmitApproval" color="primary" icon-pack="feather" icon="icon-save">
                    Save & Send Approval</vs-button>
                <vs-button @click="onClickBack()" color="danger" icon-pack="feather" icon="icon-x">Cancel</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            table: this.tableDefaultState(),
            total_value: 0,
            territory: null,
            driver: null,
            exception: null,
            summary: [],
            id: null,
            data: {
                id: null,
                driver_id: null,
                exception_id: null,
                personal_id: null,
                personal_name: "",
                territory_id: null,
                date: null,
                file: [],
                fileUrl: '',
                notes: null,
                status: null,
                json_data: [],
                status_pod: null,
                status_cit: null,
                status_closing: null,
            },
            fileAttactment: {
                multiple: true,
                disabled: false,
                value: null,
                preview: null,
                accepted_types: ["jpg", "jpeg", "png", "pdf", "doc", "docx", "xls", "xlsx"],
                files: [],
            },
            history_notes: "",
            status: 0,
            showAttachment: false,
            attachmentPath: "",
            attachment_ids: [],
            fileShow: false,
        };
    },
    mounted() {
        const routeData = this.$route.query.data;
        const routeDate = this.$route.query.date;
        const routeId = this.$route.query.id;
        if (routeId) {
            this.getData(routeId);
        } else {
            try {
                console.log("masuk route")
                this.applyData(JSON.parse(routeData), routeDate);
                localStorage.setItem("driver_page_data", JSON.stringify({
                    data: routeData,
                    date: routeDate
                }));
            } catch (error) {
                console.log("masuk local")
                console.log(error)
                const saved = localStorage.getItem("driver_page_data");

                if (saved) {
                    const parsed = JSON.parse(saved);
                    this.applyData(parsed.data, parsed.date);
                }
            }
            if (this.data.id) {
                this.getData(this.data.id);
            } else {
                this.getSummary();
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        localStorage.removeItem("driver_page_data");
        next();
    },
    methods: {
        applyData(data, date) {
            this.driver = data.personal.name;
            this.data.personal_id = data.personal.id;
            this.data.personal_name = data.personal.name;
            this.data.territory_id = data.WarehouseID;
            this.data.date = date;
            this.data.driver_id = data.id;
            this.data.id = data.detail.exc_id;
            this.exception = data.detail.exc_code;
            this.data.status_pod = data.detail.status_pod;
            this.data.status_cit = data.detail.status_cit;
            this.data.status_closing = data.detail.status_closing;
        },
        tableDefaultState() {
            return {
                data: [],
            };
        },
        onClickBack() {
            this.$router.go(-1);
        },
        needException(item) {
            if (item.pod_code == '' || ((item.so_total != 0 && item.so_total != null) && ((item.billing_total + item.invoice_total) < item.so_total))) {
                return 'Yes';
            }
            return 'No';
        },
        getSummary() {
            this.$vs.loading();
            this.$http
                .get("/api/sfa/v1/daily-closing/driver/get-summary", {
                    params: {
                        driver_id: this.data.driver_id,
                        date: this.data.date,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.summary = resp.data;
                        this.data.json_data = {
                            summary: this.summary.map(item => ({
                                do_code: item.do_code,
                                is_cod: item.is_cod,
                                pod_code: item.pod_code,
                                so_total: item.so_total,
                                billing_total: item.billing_total,
                                invoice_total: item.invoice_total,
                            }))
                        }
                    }
                    this.$vs.loading.close();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                });
        },
        getData(id) {
            this.$vs.loading();
            this.$http
                .get("/api/sfa/v1/daily-closing/driver/get-exception", {
                    params: {
                        id: id,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        console.log(resp)
                        this.data.id = resp.data.id;
                        this.exception = resp.data.exception_code
                        this.driver = resp.data.personal_name
                        this.data.territory_id = resp.data.territory_id
                        this.data.driver_id = resp.data.personal_id
                        this.data.personal_id = resp.data.personal_id
                        this.data.personal_name = resp.data.personal_name
                        this.data.date = resp.data.date
                        this.history_notes = resp.data.notes.toString().split(";")
                        this.summary = resp.data.summary.summary;
                        this.data.json_data = resp.data.summary;
                        this.data.status = resp.data.status;
                        resp.data.data_attachment.map((r, i) => {
                            this.data.file.push({
                                id: r.id,
                                name: r.name,
                                path: r.path,
                                doc_type: r.doc_type,
                            })
                        })
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                    this.$vs.loading.close();
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        handleDeleteAttachment(index, id) {
            this.data.file = this.data.file.filter((item, i) => i != index);
            this.deleteFile(id);
        },
        handleAttachment() {
            if (this.$refs.file.files[0]) {
                let a = this.$refs.file.files
                for (let i = 0; i < a.length; i++) {
                    if (a[i].size <= 5000000) { // 5mb
                        this.file = a[i];
                        this.uploadData();
                    } else {
                        this.$vs.notify({
                            title: "Error",
                            text: a[i].name + " is greater than 5MB",
                            color: "danger",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                    }
                }
                document.querySelector("#fileInput").value = "";
            } else {
                this.$vs.notify({
                    title: "Error",
                    text: "No file chosen.",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                });
            }
        },
        paramUpload() {
            var form = new FormData();
            form.append("id", this.id);
            form.append("file", this.file);
            form.append("type", this.file.type);
            return form;
        },
        uploadData() {
            this.$vs.loading();
            this.$http
                .post("/api/sfa/v1/daily-closing/driver/upload-file", this.paramUpload(), {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    console.log("RESP ATTACHMENT", resp)
                    if (resp.code == 200) {
                        this.data.file.push({
                            id: resp.data.attachment.id,
                            name: resp.data.attachment.NameFile,
                            path: resp.data.attachment.PathFile,
                            doc_type: resp.data.attachment.DocType,
                        });
                        this.attachment_ids.push(parseInt(resp.data.attachment.id))
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        deleteFile(id) {
            this.$vs.loading();
            var form = new FormData();
            form.append("id", id);
            this.$http
                .post("/api/sfa/v1/daily-closing/driver/delete-file", form, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        paramData() {
            this.data.json_data = {
                ...this.data.json_data,
                status_pod: this.data.status_pod,
                status_cit: this.data.status_cit,
                status_closing: this.data.status_closing
            };
            return {
                id: this.data.id,
                driver_id: this.data.driver_id,
                territory_id: parseInt(this.data.territory_id),
                personal_id: parseInt(this.data.driver_id),
                personal_name: this.data.personal_name,
                date: this.data.date,
                status: this.status,
                notes: this.data.notes,
                attachment_ids: this.attachment_ids,
                json_data: this.data.json_data
            };
        },
        postData() {
            console.log('param data', this.paramData())
            this.$vs.loading();
            var url = this.data.id ? "/api/sfa/v1/daily-closing/driver/update" : "/api/sfa/v1/daily-closing/driver/create";
            this.$http
                .post(url, this.paramData())
                .then((resp) => {
                    if (resp.code == 200) {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                        this.onClickBack();
                    } else {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        handleSubmitWithoutApproval() {
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Confirm`,
                text: "Please confirm to create document",
                accept: () => {
                    this.handleSubmit();
                },
            });
        },
        handleSubmit(sendApproval = false) {
            console.log("ID", this.id)
            if (sendApproval == true) {
                this.status = 1;
            }

            this.postData();
            // this.postData();
        },
        handleSubmitApproval() {
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Confirm`,
                text: "Please confirm to create & send to approval",
                accept: () => {
                    this.handleSubmit(true);
                },
            });
        },
        formatNumber(value) {
            if (value == 0 || value == null) {
                return "0"
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },
        stsExcText(sts) {
            if (sts == 0) {
                return "Open";
            } else if (sts == 1) {
                return "Waiting for Approval";
            } else if (sts == 2) {
                return "Approved";
            } else if (sts == 3) {
                return "Rejected";
            }
            return "";
        }
    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format("DD-MM-YYYY");
            }
        },
    },
};
</script>

<style>
.tabular-nums {
    font-variant-numeric: tabular-nums;
}
</style>
